// extracted by mini-css-extract-plugin
export default {"button":"ButtonsContainer_button__9Zb5K","button_cancel":"ButtonsContainer_button_cancel__uTFy8","button_version":"ButtonsContainer_button_version__Z2ZgX"};